import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface CompleteJobProgressionActionsProps {
  isAnyExtensionFlowAvailable: boolean
  onCompleteJob: () => unknown
  extensionActions?: ReactNode
}

export function CompleteJobProgressionActions({
  isAnyExtensionFlowAvailable,
  onCompleteJob,
  extensionActions,
}: CompleteJobProgressionActionsProps) {
  return (
    <>
      {!isAnyExtensionFlowAvailable && (
        <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
          <Button
            label="Complete Job"
            variant="primary"
            size="wide-slim"
            onPress={onCompleteJob}
            testId="job-progression-complete-job-button"
          />
        </CardContent>
      )}

      {extensionActions}
    </>
  )
}
